import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../../shared/styles';
import {
  DataColumn,
  NameColumn,
} from './styles';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

const DataColumnHeader = styled(DataColumn)`
  ${HeaderMixin}
`;

const ImportColumnHeader = styled(DataColumnHeader)`
  label {
    float: right;
  }
`;

export default function Header() {
  return (
    <HeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
      <DataColumnHeader>Data Provider ID</DataColumnHeader>
      <DataColumnHeader>ISIN</DataColumnHeader>
      <DataColumnHeader>APIR</DataColumnHeader>
      <DataColumnHeader>Ticker</DataColumnHeader>
      <DataColumnHeader>Stock Code</DataColumnHeader>
      <ImportColumnHeader />
    </HeaderContainer>
  );
}
